<template>
  <div>
    <a-modal
        :title="title"
        :visible="visible"
        width="100%"
        :dialog-style="{ top: '0', padding: '0', margin:'0', 'max-width': 'calc(100vw)'}"
        :body-style="isMobile() ? {padding: '0'}: {'background-color': 'rgb(236, 236, 236)'}"
        @cancel="handleCancel">
      <DetailCreateTable ref="detailCreateTable" @completeDraft="completeDraft" @emitBefore="emitBefore"
                         @emitSuccess="emitSuccess" @emitFinally="emitFinally"></DetailCreateTable>

      <template slot="footer">
        <a-button key="back" @click="handleCancel" style="margin-left: 8px">
          关闭
        </a-button>
        <a-button v-if="title === '继续完善'" type="dashed" @click="handleDraft" style="margin-left: 8px">
          保存草稿
        </a-button>
        <a-button v-if="title === '继续完善'" type="primary" :loading="submitLoading" @click="handleSubmit"
                  style="margin-left: 8px">
          确定并提交使馆
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>

import DetailCreateTable from "@/components/usDs/DetailCreateTable";
import {ResponsiveMixins} from "@/mixins/responsive-mixins";

export default {
  name: "DetailCreateModal",
  components: {DetailCreateTable},
  mixins: [ResponsiveMixins],
  data() {
    return {
      title: '',
      visible: false,
      submitLoading: false,
      // intervalId: null,
      fatherComponent: '',
    }
  },
  methods: {
    handleDraft() {
      this.$refs.detailCreateTable.handleDraft();
    },
    show(id, title, fatherComponent, isEn) {
      this.visible = true;
      this.title = title;
      this.fatherComponent = fatherComponent;
      this.$nextTick(() => {
        this.$refs.detailCreateTable.init(id, "DetailCreateModal", isEn);
      })
    },

    handleSubmit() {
      this.$refs.detailCreateTable.handleSubmit();
    },
    completeDraft(editProgress) {
      let that = this;
      that.$confirm({
        title: '温馨提示',
        content: editProgress === 100 ? '数据已经保存成功' : '数据已经保存成功，但是有必填项没有填，请您核对',
        okText: '确定',
        cancelText: '继续填',
        onOk() {
          that.handleCancel();
        },
        onCancel() {
        }
      });
    },
    emitSuccess() {
      this.handleCancel();
      this.$message.success("已提交");
    },
    handleCancel() {
      this.visible = false;
      if (this.fatherComponent) {
        this.fatherComponent.$emit('ok');
      }
    },
    emitBefore() {
      this.submitLoading = true;
    },
    emitFinally() {
      this.submitLoading = false;
    }
  },
  // watch: {
  //   visible(newVal) {
  //     if (newVal) {
  //       this.intervalId = setInterval(() => {
  //         this.$refs.detailCreateTable.handleSilentDraft();
  //       }, 60 * 1000);
  //     } else {
  //       clearInterval(this.intervalId);
  //       this.intervalId = null;
  //     }
  //   }
  // }
}

</script>

<style scoped>


</style>
